export default __webpack_public_path__ + "static/media/download-latest.0f1410b6.svg";